import React, {PropsWithChildren} from "react";
import ReactDOM from 'react-dom';
import "./Modal.scss"

export const Modal: React.FunctionComponent<PropsWithChildren> = (props) => {
    const getModalLayout = () => {
        return <div className={'modal'}>
            <div className={'modal-content'}>{props.children}</div>
        </div>
    }
    return ReactDOM.createPortal(getModalLayout(), document.body);

}